<template>
  <div class="search-tools-bar d-flex">
    <div class="flex-grow-0 d-flex align-center">
      <v-btn
        @click="goBack"
        color="secondaryButtons"
        class=""
        :size="$vuetify.display.smAndDown ? 'small' : undefined"
        elevation="0"
        variant="flat"
      >
        <v-icon>mdi-chevron-left</v-icon>
        {{ $t('common.back') }}
      </v-btn>
    </div>

    <div class="flex-grow-1 d-flex align-center pl-5">
      <h1 class="">{{ headerString }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchToolsBar",
  props: {
    headerString: {
      type: String,
      required: false,
    }
  },
  methods: {
    goBack() {
      if (window.history.state.back) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  },
};
</script>

<style>
.search-tools-bar {
  position: relative;
  padding: 12px 0 8px 0;
  z-index: 4;
  /* background-color: red; */
}

.v-theme--dark .search-tools-bar {
  background-color: #14171b;
}
.v-theme--light .search-tools-bar {
  background-color: #e6ecf1;
}
</style>
